import Icon from '@atoms/Icon/Icon';
import { IconName } from '@models/IIcon';
import useMediaQuery from '@utils/hooks/useMediaQuery';
import classNames from 'classnames';

interface Props {
  readonly isActive: boolean;
  readonly onClick: () => void;
  readonly icon?: IconName;
  readonly label: string;
  readonly rightDesktopPadding?: number;
  readonly applyPaddingOnMobile?: boolean;
}

const GalleryTabButton = ({
  isActive,
  onClick,
  icon,
  label,
  rightDesktopPadding = 15,
  applyPaddingOnMobile = false,
}: Props) => {
  const isMobile = useMediaQuery(1024);

  return (
    <button
      tabIndex={0}
      onClick={onClick}
      className={classNames(
        'group flex flex-start flex-row items-center rounded-[40px] border border-transparent bg-grey-600 py-[10px] transition-colors hover:border-yellow max-lg:px-5 lg:pl-5',
        {
          'border-yellow text-yellow': isActive,
        }
      )}
      style={{
        ...(isMobile && !applyPaddingOnMobile
          ? {}
          : {
              paddingRight: rightDesktopPadding,
            }),
      }}
    >
      {icon && (
        <div className="flex items-center justify-center pr-2.5">
          <Icon
            name={icon}
            colorClassName="transition-colors group-hover:text-yellow"
          />
        </div>
      )}

      {label && (
        <div
          key={`tab-${label}`}
          className={classNames(
            'flex w-auto flex-col items-center transition-colors group-hover:text-yellow',
            isActive ? 'text-yellow' : 'text-grey-500'
          )}
        >
          <div className="body-three whitespace-nowrap">{label}</div>
        </div>
      )}
    </button>
  );
};

export default GalleryTabButton;
